export default "__VITE_ASSET__Bi60Niz$__"